/**
 * PropertyTypes Component
 *
 * Grid of property type categories for quick filtering.
 * Uses custom PNG icons from /icons/categories/
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../../../components/layout';

interface PropertyType {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

// Property types with real counts from database
const PROPERTY_TYPES: PropertyType[] = [
  {
    name: 'Chalets',
    slug: 'chalet',
    icon: '/icons/categories/chalet.png',
    count: 30,
  },
  {
    name: 'Apartments',
    slug: 'apartment',
    icon: '/icons/categories/apartment.png',
    count: 26,
  },
  {
    name: 'Houses',
    slug: 'house',
    icon: '/icons/categories/house.png',
    count: 17,
  },
  {
    name: 'Cabins',
    slug: 'cabin',
    icon: '/icons/categories/cabin.png',
    count: 10,
  },
  {
    name: 'Villas',
    slug: 'villa',
    icon: '/icons/categories/villa.png',
    count: 6,
  },
  {
    name: 'Caravans',
    slug: 'caravan',
    icon: '/icons/categories/caravan.png',
    count: 4,
  },
  {
    name: 'Studios',
    slug: 'studio',
    icon: '/icons/categories/studio.png',
    count: 3,
  },
  {
    name: 'Condos',
    slug: 'condo',
    icon: '/icons/categories/condo.png',
    count: 1,
  },
];

export const PropertyTypes: React.FC = () => {
  return (
    <section className="py-16">
      <Container>
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Browse by type
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Pick what you sleep in
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-4">
          {PROPERTY_TYPES.map((type) => (
            <Link
              key={type.slug}
              to={`/search?type=${type.slug}`}
              className="group flex flex-col items-center p-4 bg-white rounded-2xl border border-gray-200 hover:border-primary-300 hover:shadow-lg transition-all"
            >
              <div className="w-16 h-16 mb-3 flex items-center justify-center">
                <img
                  src={type.icon}
                  alt={type.name}
                  className="w-full h-full object-contain opacity-80 group-hover:opacity-100 transition-opacity"
                />
              </div>
              <h3 className="font-semibold text-gray-900 text-sm text-center mb-1">{type.name}</h3>
              <p className="text-xs text-gray-500">{type.count} properties</p>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default PropertyTypes;
